import React, { useState, useEffect, forwardRef, useImperativeHandle, useContext } from 'react';
import { Row } from "antd";
import { ActionLogList } from './ActionLogList';
import { ActionLogData } from './ActionLogData';
import { AppContext } from '../../util/context';
import '../../pages/ActionTracker/ActionTracker.css';

export const ActionLog = forwardRef(({
    data, 
    StyledDiv,
    isRep,
    viewOnly,
    assignedView,
    actionLogDataRef,
    logValidationErrors,
    setLogValidationErrors,
    actionID,
    allEmployees,
    hazardMode
}, ref) => {
    const {
        userData
    } = useContext(AppContext);
    const [selectedAction, setSelectedAction] = useState(0); 
    const [allowChange, setAllowChange] = useState(false);
    const [actionData, setActionData] = useState(null);
    
    const handleActionSelection = (index) => {
        setSelectedAction(index);
        setAllowChange(true);
    }

    useEffect(() => {
        let mounted = true; 

        const getActionData = async () => {
            if(data.actions.length > 0){
                let action
                
                if(actionID !== undefined && !allowChange){
                    action = data.actions.find(action => action.id === actionID);
                } 
                else if(actionID === undefined || allowChange){
                    action = data.actions[selectedAction];
                }
                
                if(( isRep || viewOnly ) || (assignedView && action.assignedTo === userData.given_name + " " + userData.family_name)){
                    setActionData(action);
                }
            }
        }

        if (mounted) {
            getActionData();
        }

        return () => mounted = false;
    }, [selectedAction, actionID, assignedView, data.actions, isRep, userData, viewOnly, allowChange]);

    useImperativeHandle(ref, () => ({
        getActionData: () => actionData
    }));

    return (
        <>
            <Row
                style={{
                    height: "83%"
                }}
            >

                <ActionLogList 
                    data={data} 
                    isRep={isRep}
                    viewOnly={viewOnly}
                    assignedView={assignedView}
                    selectedAction={actionID !== undefined && !allowChange ? data.actions.findIndex(action => action.id === actionID) : selectedAction} 
                    handleActionSelection={handleActionSelection} 
                    StyledDiv={StyledDiv}
                    setLogValidationErrors={setLogValidationErrors}
                />

                {actionData && <ActionLogData 
                    actionData={actionData}
                    StyledDiv={StyledDiv} 
                    isRep={isRep}
                    viewOnly={(data.status === "closed" || data.status === 'void') ? true : viewOnly}
                    assignedView={assignedView}
                    selectedAction={selectedAction}
                    logValidationErrors={logValidationErrors}
                    setLogValidationErrors={setLogValidationErrors}
                    allEmployees={allEmployees}
                    hazardMode={hazardMode}
                    ref={actionLogDataRef}
                />}

            </Row>
        </>
    )
})
